import { useTranslation } from 'react-i18next';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

const LanguageSelector = () => {
  const { i18n } = useTranslation();
  const supportLanguages = [
    { key: 'ko', value: '한국어' },
    { key: 'en', value: 'English' },
    { key: 'ja', value: '日本語' },
  ];
  const [selectedLanguage, setSelectedLanguage] = useState<{ key: string; value: string }>(
    supportLanguages[0],
  );
  const [showMenu, setShowMenu] = useState(false);

  useEffect(() => {
    const language = localStorage.getItem('i18nextLng');
    if (language) {
      setSelectedLanguage(
        supportLanguages.find((lang) => lang.key === language) ?? supportLanguages[0],
      );
    }
  }, []);

  return (
    <Layout
      onClick={() => {
        setShowMenu((prev) => !prev);
      }}
    >
      <img src="/images/text.svg" alt="text" />
      <svg xmlns="http://www.w3.org/2000/svg" width="2" height="12" viewBox="0 0 2 12" fill="none">
        <path d="M1 0V12" stroke="#E4E4E4" />
      </svg>
      <TextStyle>{selectedLanguage.value}</TextStyle>
      <img src="/images/downArrow.svg" alt="voice" />
      {showMenu && (
        <Menu>
          {supportLanguages.map((language) => (
            <MenuItem
              key={language.key}
              onClick={() => {
                setSelectedLanguage(language);
                i18n.changeLanguage(language.key);
              }}
            >
              {language.value}
            </MenuItem>
          ))}
        </Menu>
      )}
    </Layout>
  );
};

const Layout = styled.div`
  position: relative;
  cursor: pointer;
  display: inline-flex;
  padding: 12px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 8px;
  border: 1px solid var(--Grayscale-20, #e4e4e4);
  background: var(--Grayscale-0, #fff);
  @media ${(props) => props.theme.media.mobile} {
    padding: 8px 12px;
  }
`;

const TextStyle = styled.div`
  color: var(--Grayscale-80, #2d2d2d);
  font-family: Montserrat;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 18px */
  letter-spacing: -0.03px;
  text-transform: uppercase;
`;

const Menu = styled.div`
  position: absolute;
  top: calc(100% + 8px);
  left: 0;
  width: 100%;
  border-radius: 8px;
  overflow: hidden;
  text-transform: uppercase;
  color: var(--Grayscale-90, #1d1d1d);

  /* 15 medium */
  font-family: Pretendard;
  font-size: 15px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 22.5px */
  letter-spacing: -0.037px;

  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
`;

const MenuItem = styled.div`
  padding: 16px 20px;
  background: #fff;

  &:hover {
    background: var(--Grayscale-5, #f8f8f8);
  }
`;

export default LanguageSelector;
